import './style.css';
import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls';

// Setup

const scene = new THREE.Scene();

const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);

const renderer = new THREE.WebGLRenderer({
  canvas: document.querySelector('#bg'),
});

renderer.setPixelRatio(window.devicePixelRatio);
renderer.setSize(window.innerWidth, window.innerHeight);
camera.position.setZ(30);
camera.position.setX(-3);

renderer.render(scene, camera);

// Torus

const geometry = new THREE.TorusGeometry(10, 3, 16, 100);
const material = new THREE.MeshStandardMaterial({ color: 0xff6347 });
const torus = new THREE.Mesh(geometry, material);

// Lights

const pointLight = new THREE.PointLight(0xffffff);
pointLight.position.set(5, 5, 5);

const ambientLight = new THREE.AmbientLight(0xffffff);
scene.add(pointLight, ambientLight);




// Background
const spaceTexture = new THREE.TextureLoader().load('space.jpg');
scene.background = spaceTexture;
// Avatar

const selfieTexture = new THREE.TextureLoader().load('Selfie2.jpg');

const me = new THREE.Mesh(new THREE.BoxGeometry(3, 3, 3), new THREE.MeshBasicMaterial({ map: selfieTexture }));

scene.add(me);

// Moon

const moonTexture = new THREE.TextureLoader().load('moon.jpg');
const normalTexture = new THREE.TextureLoader().load('normal.jpg');

const moon = new THREE.Mesh(
  new THREE.SphereGeometry(3, 32, 32),
  new THREE.MeshStandardMaterial({
    map: moonTexture,
    normalMap: normalTexture,
  })
);

scene.add(moon);

moon.position.z = 30;
moon.position.setX(-10);

me.position.z = -5;
me.position.x = 2;

const html = new THREE.TextureLoader().load('HTML_Logo.png');
const css = new THREE.TextureLoader().load('CSS_Logo.png');
const js = new THREE.TextureLoader().load('JS_4.png');

function getRndInteger(min, max) {
  return Math.floor(Math.random() * (max - min) ) + min;
}

const logoArray = new Array(500);


function addLogos()
{
  const logoGeo = new THREE.SphereGeometry(0.5);
  let logoChoice = getRndInteger(1,4);
  let logoMat = new THREE.MeshBasicMaterial({map:html});
  //const logoMat = new THREE.MeshBasicMaterial({map:html}); //new THREE.MeshBasicMaterial({map:html})
  switch(logoChoice){
    case 1:
      logoMat = new THREE.MeshBasicMaterial({map:html});
      break;
    case 2:
      logoMat = new THREE.MeshBasicMaterial({map:css});
      break;
    case 3:
      logoMat = new THREE.MeshBasicMaterial({map:js});
       break;
  }
  const logoBox = new THREE.Mesh(logoGeo,logoMat);
  const [x,y,z] = Array(3).fill().map(() => THREE.MathUtils.randFloatSpread(100));

  logoBox.position.set(x,y,z);
  scene.add(logoBox);
  logoArray.push(logoBox);
}

Array(500).fill().forEach(addLogos);


// Scroll Animation

function moveCamera() {
  const t = document.body.getBoundingClientRect().top;
  moon.rotation.x += 0.05;
  moon.rotation.y += 0.075;
  moon.rotation.z += 0.05;

  me.rotation.y += 0.01;
  me.rotation.z += 0.01;

  logoArray.forEach((element)=>element.rotation.z+=0.01);
  logoArray.forEach((element)=>element.rotation.x+=0.01);
  logoArray.forEach((element)=>element.rotation.y+=0.01);

  camera.position.z = t * -0.005;
  camera.position.x = t * -0.0002;
  camera.rotation.y = t * -0.0002;
}


document.body.onscroll = moveCamera;
moveCamera();

// Animation Loop

function animate() {
  requestAnimationFrame(animate);

  moon.rotation.x += 0.005;
  logoArray.forEach((element)=>element.rotation.z+=0.01);
  // controls.update();

  renderer.render(scene, camera);
}

animate();
